import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Instagram, Facebook, Mail } from "lucide-react";
import { CLINIC, ASSETS } from "@/constants/site";
import { TESTIDS } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer data-testid={TESTIDS.footer} className="bg-slate-900 text-slate-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <img src={ASSETS.logo} alt="Visiovet" className="h-11 w-auto brightness-0 invert" />
          </div>
          <p className="text-sm text-slate-400 leading-relaxed">
            Centro de diagnóstico por imagem veterinária em Belo Horizonte. Tecnologia de ponta e equipe especializada.
          </p>
        </div>

        <div>
          <h3 className="text-white font-heading font-semibold mb-4">Serviços</h3>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-brand-400" to="/servicos">Ressonância Magnética</Link></li>
            <li><Link className="hover:text-brand-400" to="/servicos">Tomografia Computadorizada</Link></li>
            <li><Link className="hover:text-brand-400" to="/servicos">Ultrassonografia</Link></li>
            <li><Link className="hover:text-brand-400" to="/servicos">Raio-X Digital</Link></li>
            <li><Link className="hover:text-brand-400" to="/servicos">Coleta de Exames Laboratoriais</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-heading font-semibold mb-4">Contato</h3>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-brand-400 shrink-0" /><span>{CLINIC.address}</span></li>
            <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-brand-400 shrink-0" /><span>{CLINIC.phoneMobile} · {CLINIC.phoneLandline}</span></li>
            <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-brand-400 shrink-0" /><span>{CLINIC.email}</span></li>
            <li className="flex gap-3"><Clock className="w-4 h-4 mt-0.5 text-brand-400 shrink-0" /><span>{CLINIC.hours.weekdays}<br/>{CLINIC.hours.saturday}</span></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-heading font-semibold mb-4">Siga-nos</h3>
          <div className="flex gap-3">
            <a href={CLINIC.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram Visiovet"
              className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center hover:border-brand-400 hover:text-brand-400 transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={CLINIC.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook Visiovet"
              className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center hover:border-brand-400 hover:text-brand-400 transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
          </div>
          <p className="mt-6 text-xs text-slate-500">
            Atendimento apenas com encaminhamento veterinário.
          </p>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Visiovet Diagnóstico Veterinário. Todos os direitos reservados.</span>
          <Link to="/admin/login" className="hover:text-brand-400">Área restrita</Link>
        </div>
      </div>
    </footer>
  );
}
